import React from "react";
import ListeDemandesTable from "./ListeDemandesTable";
import { TiExport } from "react-icons/ti";
import { useExportXls } from "../../../../utils/hooks/useExportXls";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from "date-fns/locale/fr";
registerLocale("fr", fr);

const ListeDemandes = () => {
  const handleExport = useExportXls("export_paiements", "demandes_paiements.xls");

  return (
    <div className="dashboard-admin-component">
      <div className="container-dashboard-page bg-white p-3">
        <div className="admin-page-title-header-container flex-sb align-items-center">
          <div className="crypta-dash-locataire-requetes-header">
            <h4 className="crypta-dash-header-titre">Demandes de paiements</h4>
          </div>
          <div className="content-btn-add-theme">
            <button className="btn btn-export-csv" onClick={handleExport}>
              <TiExport style={{ color: "#08BB90", fontSize: 20 }} />
              <span className="ps-2">Export EN Xls</span>
            </button>
          </div>
        </div>
        <div className="col-left-dashboard col-left-dashboard-responsive mb-3">
          <ListeDemandesTable />
        </div>
      </div>
    </div>
  );
};

export default ListeDemandes;
